var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7112_47759",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7112_47759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.775 18.9242L20 17.1492V11.9992H14.85L10.85 7.99922H20V5.99922H8.85002L6.85002 3.99922H20C20.55 3.99922 21.0209 4.19505 21.4125 4.58672C21.8042 4.97839 22 5.44922 22 5.99922V17.9992C22 18.1659 21.9834 18.3284 21.95 18.4867C21.9167 18.6451 21.8584 18.7909 21.775 18.9242ZM9.15002 11.9992H4.00002V17.9992H15.15L9.15002 11.9992ZM20.45 23.2992L17.15 19.9992H4.00002C3.45002 19.9992 2.97919 19.8034 2.58752 19.4117C2.19586 19.0201 2.00002 18.5492 2.00002 17.9992V5.99922C2.00002 5.44922 2.19586 4.97839 2.58752 4.58672C2.97919 4.19505 3.45002 3.99922 4.00002 3.99922L6.00002 5.99922H4.00002V7.99922H5.15002L0.650024 3.49922L2.07502 2.07422L21.875 21.8742L20.45 23.2992Z",
    fill: "#415364"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardOff);
export default __webpack_public_path__ + "static/media/credit_card_off.2e557da9f5756b1931ca474867bdbb07.svg";
export { ForwardRef as ReactComponent };